import React from 'react';
import TextMessage from './TextMessage';
import CardMessage from './CardMessage';
import TableMessage from './TableMessage';
import JsonStructure from './JsonStructure';
import ImageMessage from './ImageMessage';
import PdfMessage from './PdfMessage';
import FeedbackQuestionMessage from './FeedbackQuestionMessage';

const MessageRenderer = ({ message, labels, onFeedbackSubmit }) => {
    const contentType = message?.contentType || 'text';

    if (contentType === 'card') {
        return <CardMessage structuredData={message?.structuredData} />;
    }

    if (contentType === 'table') {
        return <TableMessage structuredData={message?.structuredData} />;
    }

    if (contentType === 'json') {
        return <JsonStructure structuredData={message?.structuredData} />;
    }

    if (contentType === 'image') {
        return <ImageMessage structuredData={message?.structuredData} labels={labels} />;
    }

    if (contentType === 'pdf') {
        return <PdfMessage structuredData={message?.structuredData} labels={labels} />;
    }

    if (contentType === 'feedback_question') {
        return <FeedbackQuestionMessage structuredData={message?.structuredData} labels={labels} onSubmit={onFeedbackSubmit} />;
    }

    return <TextMessage role={message?.role} content={message?.content} />;
};

export default MessageRenderer;
